import React from 'react';

import { InfoBlockContext } from './InfoBlockContext';

type InfoBlockProviderProps = {
  loading?: boolean;
};

export const InfoBlockProvider: React.FC<React.PropsWithChildren<InfoBlockProviderProps>> = ({
  loading = false,
  children,
}) => {
  return <InfoBlockContext value={{ loading }}>{children}</InfoBlockContext>;
};
